import { render } from "./CartaNautica.vue?vue&type=template&id=bb208656&scoped=true"
import script from "./CartaNautica.vue?vue&type=script&lang=js"
export * from "./CartaNautica.vue?vue&type=script&lang=js"

import "./CartaNautica.vue?vue&type=style&index=0&id=bb208656&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb208656"]])

export default __exports__